import React from 'react';
import { Modal } from 'antd';
import ContentQuiz from './index';

const ContentQuizModal = ({ open, onClose, courseId, contentId, course, onQuizCompleted }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={920}
      destroyOnClose
      centered
      className="content-quiz-modal-container"
      bodyStyle={{ padding: 0, maxHeight: '85vh', overflowY: 'auto' }}
    >
      <ContentQuiz
        modalMode={true}
        propCourseId={courseId}
        propContentId={contentId}
        propCourse={course}
        onClose={onClose}
        onQuizCompleted={onQuizCompleted}
      />
    </Modal>
  );
};

export default ContentQuizModal;
